// @ts-nocheck
import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import Select from '@/components/form-control/Select'
import { queryKeys } from '@/constant/common'
import { useAuthContext } from '@/features/auth/context'
import { useSearchController } from '@/features/config/hooks/controller'
import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import { Button, Stack, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import * as yup from 'yup'
import { useSetUpUI } from '../../context'
import classes from './styles.module.scss'
import useTranslation from '@/hooks/useTranslation'

const schema = yup.object({
  configuration: yup.mixed().required('Configuration is required'),
})

interface ConfigurationProps {
  isPaging: boolean
  isSuccessful: boolean
  errors: string[]
}

const ConfigurationModal = () => {
  const { t } = useTranslation()
  const { closeModal } = useSetUpUI()
  const { interfaceId } = useAuthContext()
  const [page, setPage] = useState<number>(1)
  const [loadingConfig, setLoadingConfig] = useState<boolean>(false)
  const [dataConfiguration, setDataConfiguration] =
    useState<ConfigurationProps>()
  const [configurationId, setConfigurationId] = useState<number>()
  const { refetch } = useSearchController({ PageSize: 0 }, interfaceId)

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      configuration: null,
    },
  })

  const expandItem = (item: any, maxLevel: number = 3) => {
    maxLevel--
    let result = []
    if (maxLevel > 0) {
      result.push(item)
      if (item.subOrganizations)
        result.push(...expandHierarchy(item.subOrganizations, maxLevel))
    }
    return result
  }

  const expandHierarchy = (array: any[], maxLevel: number = 3): any[] => {
    let result = []
    for (const i of array) {
      result.push(...expandItem(i, maxLevel))
    }
    return result
  }

  const getConfiguration = async () => {
    try {
      const { data } = await controllerDataConfigApi
        .getIOConfiguration(interfaceId)
        .then((data) => {
          let result = expandHierarchy(data.data, 4)
          const combined = [...result]
          data.data.data = combined
          return data
        })
      return data
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }

  useEffect(() => {
    if (dataConfiguration && dataConfiguration.isPaging) {
      const errorMessage = dataConfiguration.errors.join(', ')
      toast.error(errorMessage)
      setPage(page + 1)
    } else {
      setLoadingConfig(false)
      refetch()
    }
    return
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataConfiguration])

  useEffect(() => {
    async function fetchData() {
      if (dataConfiguration) {
        try {
          const response = await controllerDataConfigApi.updateConfiguration({
            interfaceId: interfaceId,
            configuration: configurationId || 0,
            page: page,
            errors: [],
          })
          if (response) {
            toast.success(t('updateConfigurationSuccess'))
            setDataConfiguration(response.data)
          } else {
            setLoadingConfig(false)
          }
        } catch (error) {}
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  const queryClient = useQueryClient()

  const handleSave = async (data: any) => {
    setLoadingConfig(true)
    setConfigurationId(data?.configuration?.id)
    const res = await controllerDataConfigApi.updateConfiguration({
      interfaceId: interfaceId,
      configuration: data?.configuration?.id,
      page: page,
      errors: [],
    })

    if (res) {
      setDataConfiguration(res.data)
      queryClient.invalidateQueries([queryKeys.controller])
      if (!res.data?.isPaging) {
        toast.success(t('updateConfigurationSuccess'))
        closeModal()
      }
    } else {
      setLoadingConfig(false)
    }
  }

  const handleClose = () => {
    closeModal()
    refetch()
  }

  return (
    <Stack
      sx={{
        backgroundColor: 'background.default',
        minWidth: '450px',
        minHeight: '216px',
        padding: '32px 40px',
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography className={classes.txtApplyConfiguration}>
          Apply Configuration
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            variant="secondary"
            className={classes.btnConfiguration}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="primary"
            className={classes.btnConfiguration}
            onClick={form.handleSubmit(handleSave)}
            loading={loadingConfig}
          >
            Save
          </LoadingButton>
        </Stack>
      </Stack>
      <Stack mt="30px">
        <Typography className={classes.txtApplyConfiguration}>
          Apply Configuration to all output decoders
        </Typography>
        <Stack mt="10px" width="100%">
          {getConfiguration && (
            <Select
              label="Select one"
              name="configuration"
              form={form}
              bindKey="id"
              bindLabel="description"
              getOptions={getConfiguration}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ConfigurationModal
